import { Modal, Toast, Utils } from 'common';
import React, { useContext, useRef, useState } from 'react';
import AddPaymentMethod from '../fsui/AddPaymentMethod.component';

const { Session, UserRole, Communication } = Utils;
const { ToastContext } = Toast;
const { ModalContext } = Modal;

export const useBankConnection = onClose => {
	const [isConnecting, setIsConnecting] = useState(false);
	const { showToast } = useContext(ToastContext);
	const { showError } = useContext(ModalContext);
	const addPaymentMethodRef = useRef();

	const showSuccessToast = () => {
		showToast({
			toastType: 'success',
			summary:
				'Your bank account is now the payment method assigned to Account Funds.',
			detail: 'You can update your payment methods in settings anytime.',
			position: 'top-right',
			sticky: true,
		});
	};

	const isForCorpAccount = () => {
		const userRole = Session.getUserRole();
		return userRole === UserRole.CorpAdmin || userRole === UserRole.RegionAdmin;
	};

	const handleConnectBank = () => {
		setIsConnecting(true);

		if (addPaymentMethodRef?.current?.handleSubmit) {
			addPaymentMethodRef.current.handleSubmit();
		} else {
			setIsConnecting(false);
		}
	};

	const handlePaymentCallback = response => {
		setIsConnecting(false);

		if (!Communication.isSuccessful(response)) {
			showError({ response });
		}

		showSuccessToast();

		if (onClose) {
			onClose();
		}
	};

	// Hidden Ui Component to leverage AddPaymentMethod logic without showing modal
	const renderAddPaymentMethod = () => (
		<div className="visually-hidden">
			<AddPaymentMethod
				ref={addPaymentMethodRef}
				callback={handlePaymentCallback}
				autoSelectPayByBank={true}
				isForCorpAccount={isForCorpAccount()}
			/>
		</div>
	);

	return {
		isConnecting,
		handleConnectBank,
		renderAddPaymentMethod,
	};
};
